// NavigationListener.js
import { useEffect } from 'react'
import { useLocation, useNavigationType } from 'react-router-dom'
import { useSelector, useDispatch } from 'react-redux'
import { setNavbarActiveItem, setNavbarHeader } from './redux/slices/navbar/navbar-header.slice'

//Finds the active route by matching pathname against the route list.
const findActiveRoute = (routes, pathname) => {
  if (!routes) return null

  for (let i = 0; i < routes.length; i++) {
    const route = routes[i]

    if (route.config_path && pathname.includes(route.config_path)) {
      return route
    }

    if (route.children) {
      const childMatch = findActiveRoute(route.children, pathname)
      if (childMatch) return childMatch
    }
  }

  return null
}

const createRouteMap = (allRouteList = []) => {
  return new Map(allRouteList.map((r) => [r.nav_id, r]))
}

export const getTopParentLabel = (activeItem, allRouteList) => {
  if (!activeItem) return ''

  const routeMap = createRouteMap(allRouteList)
  let current = activeItem

  while (current?.parent_nav_id && routeMap?.has(current.parent_nav_id)) {
    current = routeMap.get(current.parent_nav_id)
  }

  return current?.config_label ?? ''
}

const NavigationListener = () => {
  const location = useLocation()
  const navigationType = useNavigationType()
  const dispatch = useDispatch()
  const { allRouteList } = useSelector((state) => state.routeData)
  const fullUrl = window.location.href

  useEffect(() => {
    // Save the *previous* route before this one
    const prevRoute = sessionStorage.getItem('currentRoute')

    if (prevRoute) {
      sessionStorage.setItem('lastVisitedRoute', prevRoute)
    }

    // Always update current route
    sessionStorage.setItem('currentRoute', location.pathname)
  }, [location, navigationType])

  useEffect(() => {
    // Try standard way first (works for proper URLs)
    const match = fullUrl.match(/[?&]referrer=([^&#?]+)/)

    if (match) {
      const referrer = match[1]
      sessionStorage.setItem('referrer', referrer)
    }
  }, [fullUrl])

  useEffect(() => {
    const activeName = findActiveRoute(allRouteList, location.pathname)
    if (activeName) {
      const topParentLabel = getTopParentLabel(activeName, allRouteList)
      dispatch(setNavbarActiveItem(activeName))
      dispatch(setNavbarHeader(topParentLabel))
    }
  }, [location.pathname, allRouteList])

  return null
}

export default NavigationListener
